import React from "react";
import {
  Datagrid,
  List,
  Loading,
  TextField,
  TopToolbar,
} from "react-admin";
import { Box } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { CustomExportButton, CustomImportButton } from "../../Signet/util";

const NetsuiteRingFinishResource = "netsuite/ring-finish";

const useStyles = makeStyles({
  container: {
    width: "100%",
    padding: 0,
  },
});

const RingFinishListActions = (props) => {
  const classes = useStyles();
  return (
    <TopToolbar className={classes.container}>
      <Box
        display={"flex"}
        alignItems={"flex-end"}
        justifyContent="space-between"
        width={"100%"}
        sx={{ paddingBottom: "14px", paddingTop: "14px" }}
      >
        <Box
          display={"flex"}
          alignItems={"center"}
          justifyContent="space-between"
        >
        </Box>
        <Box display={"flex"} justifyItems={"flex-end"} sx={{ gap: "20px" }}>
          <CustomImportButton resource={NetsuiteRingFinishResource} />
          <CustomExportButton resource={NetsuiteRingFinishResource} />
        </Box>
      </Box>
    </TopToolbar>
  );
};

const RingFinishList = (props) => {
  const { permissions } = props;

  if (!permissions) return <Loading />;
  return (
    <List {...props} exporter={false} bulkActionButtons={false} actions={<RingFinishListActions />}>
      <Datagrid rowClick={null}>
        <TextField source="first_ring_finish" label="First Ring Finish" sortable={false} />
        <TextField source="second_ring_finish" label="Second Ring Finish" sortable={false} />
        <TextField source="accent_ring_finish" label="Accent Ring Finish" sortable={false} />
        <TextField source="netsuite_id" sortable={false} label="Netsuite ID" />
        <TextField source="netsuite_value" sortable={false} label="Netsuite Value" />
      </Datagrid>
    </List>
  );
};

export default RingFinishList;
